import { useMemo } from 'react';
import { useConfiguration } from '../context/configurationContext';
import { reduceAttributes } from '../util/attributes';
import { pickCategoryFields } from '../util/fieldHelpers';

export const useListingAttributes = (publicData, limit) => {
  const config = useConfiguration();

  const attributesData = useMemo(() => {
    const {
      listing: { listingFields },
      categoryConfiguration: { key: categoryPrefix, categories: listingCategoriesConfig },
    } = config;

    const categoriesObj = pickCategoryFields(
      publicData,
      categoryPrefix,
      1,
      listingCategoriesConfig
    );
    const currentCategories = Object.values(categoriesObj);

    const fields = listingFields.reduce(reduceAttributes(publicData, currentCategories), {});
    const fieldValues = Object.values(fields);

    if (!limit) {
      return fieldValues;
    }

    return fieldValues.slice(0, limit);
  }, [config, publicData, limit]);

  return attributesData;
};
